module.exports = __webpack_public_path__ + "img/14.653c2856.jpg";